import { render, staticRenderFns } from "./UpdateBrandModal.vue?vue&type=template&id=5429ca15&"
import script from "./UpdateBrandModal.vue?vue&type=script&lang=ts&"
export * from "./UpdateBrandModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports